<script>
  export let idUnico = 'lista';
  export let content;
  import { onMount } from 'svelte';

  let indexBegin;
  let indexEnd;
  let type;

  indexBegin = content.search('{');
  indexEnd = content.search('}');
  type = content.substring(indexBegin + 1, indexEnd);

  let items = content.substring(indexEnd + 1, content.length).split(';;');

  items = items.slice(0, -1);

  onMount(() => {
    // type = 'I';
  });
</script>

<div class="container" id={idUnico}>
  {#if type != ''}
    <ol {type}>
      {#each items as items, index}
        <li>{items}</li>
      {/each}
    </ol>
  {:else}
    <ul>
      {#each items as items, index}
        <li>{items}</li>
      {/each}
    </ul>
  {/if}
</div>

<style>
  ul li,
  ol li {
    font-weight: 400;
    padding-left: 15px;
    color: var(--COR_FONTE);
    margin-bottom: 1rem;
  }

  ::marker {
    content: '\f054';
    color: var(--VERDE_CLARO);
    font-family: 'Font Awesome 6 Free';
    font-weight: 700;
  }

  @media (max-width: 767px) {
    ul {
      padding-left: 20px;
    }
  }
</style>
